import React, { Component } from "react";
import { Subscribe } from "unstated";
import StateContainer from "../../../state/StateContainer";
import NavbarButton from "../NavbarButton/NavbarButton";

class StateButtonArray extends Component {
  state = {
    scrollable: false,
  };


  /**
   * Assigns the navbar a scrollable class depending on how much space its buttons take up.
   */
  setNavbarScrollable() {
    if(!this.props.customButtons) return
    const buttonsInNavbar = this.props.customButtons.filter((button) => button.actions[0].element === "stateView" && button.isDefault)
    
    const effectiveScreenHeight = ((window.innerWidth *0.5625) *0.38);

    if( effectiveScreenHeight /64 < buttonsInNavbar.length ) {
      this.setState({scrollable: true})
      return
    }
    this.setState({scrollable: false})
  }

  /**
   * Returns the id of the state that the button is supposed to switch to.
   * @param actionParameter Action parameter that contains the name of which state to switch to
   * @param states Array of states from the API
   */
  getIdOfButtonState(actionParameter,states) {
    for (let i = 0; i < states.length; i++) {
      const state = states[i];
      if(state.name === actionParameter) {
        return state.id
      }
      
    }
  }

  /**
   * Returns a button class depending on whether its buttons state is active.
   * @param action That buttons action
   * @param currentState Current floor/state index
   * @param states Array containing all states
   */
  getButtonClass(action,currentState,states) {
    if(!action) return false
    const stateIdOfButtonPressed = this.getIdOfButtonState(action.parameter,states);
    if( action && currentState === stateIdOfButtonPressed) {
      return "button button-navbar-active"
    }
    return false
  }

  componentDidMount() {
    window.addEventListener("setupDefaultState",()=> {
      this.setNavbarScrollable()

    })
    window.addEventListener("resize",()=>{
      this.setNavbarScrollable()
    })
  }
  

  render() {
    let { scrollable } = this.state
    return (
      <Subscribe to={[StateContainer]}>
        {(state2) => (
          <div
          id="scrollbar"
            className={scrollable? "scrollable":""}
          >
          <div
            className={`middle__button-container`}
          >
            {this.props.customButtons
                  ?.filter((button) => button.actions[0].element === "stateView" && button.isDefault) //TODO: namestiti da se filtrira po tome da je prva akcija state i default = true
                  .map((button) => {
                    return (
                      <NavbarButton
                        key={button.name}
                        buttonContent={button.text}
                        buttonData={button}
                        buttonClass={
                          this.getButtonClass(button.actions[0],state2.state.currentState,state2.state.jsonData.states)? "button button-navbar-active"
                          : "button"
                        }
                      />
                    );
                  })
              }
          </div>
          </div>
        )}
      </Subscribe>
    );
  }
}

export default StateButtonArray;
